var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTarjetas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2,16h16c1.1,0,2-.9,2-2V2c0-1.1-.9-2-2-2H2C.9,0,0,.9,0,2v12c0,1.1.9,2,2,2ZM2,4h16v4H2v-4ZM2.75,11.25h4c.41,0,.75.34.75.75s-.34.75-.75.75H2.75c-.41,0-.75-.34-.75-.75s.34-.75.75-.75Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarjetas);
export default __webpack_public_path__ + "static/media/tarjetas.1b4e5454.svg";
export { ForwardRef as ReactComponent };